import { studioConstants } from "../actions/constants/studioConstants";
import { success, failure, request } from "@/utils/constants";

const initialState = {
    studios: null,
    error: null,
    loading: false,
    success: false,
};

const citiesInitialState = {
    cities: [],
    error: null,
    loading: false,
    success: false,
}

export const studioListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case studioConstants.listStudiosRequest:
            return {
                ...request,
            };
        case studioConstants.listStudiosSuccess:
            return {
                ...success,
                studios: action.payload,
            };
        case studioConstants.listStudiosFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};

export const viewStudioReducer = (state = {}, action: any) => {
    switch (action.type) {
        case studioConstants.viewStudioRequest:
            return {
                ...request,
            };
        case studioConstants.viewStudioSuccess:
            return {
                ...success,
                studioDetails: action.payload,
            };
        case studioConstants.viewStudioFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};

export const updateStudioReducer = (state = {}, action: any) => {
    switch (action.type) {
        case studioConstants.updateStudioRequest:
            return {
                ...request,
            };
        case studioConstants.updateStudioSuccess:
            return {
                ...success,
                studio: action.payload,
            };
        case studioConstants.updateStudioFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};


export const studioCityReducer = (state = citiesInitialState, action: any) => {
  switch (action.type) {
    case studioConstants.getStudioCityRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case studioConstants.getStudioCitySuccess:
      return {
        ...state,
        loading: false,
        success: true,
        cities: action.payload,
      };
    case studioConstants.getStudioCityFailure:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const deactivateStudioReducer = (state = {}, action: any) => {
    switch (action.type) {
        case studioConstants.deactivateStudioRequest:
            return {
                ...request,
            };
        case studioConstants.deactivateStudioSuccess:
            return {
                ...success,
                studio: action.payload,
            };
        case studioConstants.deactivateStudioFailure:
            return {
                ...failure,
            };
        case studioConstants.resetDeactivateStudio:
            return {};
        default:
            return state;
    }
};

export const reactivateStudioReducer = (state = {}, action: any) => {
    switch (action.type) {
        case studioConstants.reactivateStudioRequest:
            return {
                ...request,
            };
        case studioConstants.reactivateStudioSuccess:
            return {
                ...success,
                studio: action.payload,
            };
        case studioConstants.reactivateStudioFailure:
            return {
                ...failure,
            };
        case studioConstants.resetReactivateStudtio:
            return {};
        default:
            return state;
    }
};
